import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const WERO: PaymentMethod = {
    id: PAYMENT_METHOD_ID.Wero,
    name: 'wero',
    displayName: 'Wero'
};
